export class StudentTimetablePortalCoreDataResponse {
    ASRKey: string;
    PRID: string;
    Surname: string;
    OtherNames: string;
    Title: string;
    CampusID: string;
    LevelOfStudy: string;
    FeeStatus: string;
}